export default {
  units: {
    itself: 'Units',
    symbol: 'Symbol',
    symbolRequired: 'Symbol is required',
    editUnit: 'Edit unit',
    createUnit: 'Create unit',
  },
};
